import type { Feedback } from "./ui-types";

export function mutationSuccessFeedback(successMessage: string, outstandingCount: number, simulated: boolean, demo: boolean): Feedback {
  const hostOutstanding = !demo && outstandingCount > 0;
  return {
    tone: hostOutstanding ? "warning" : "success",
    message: successMessage + (hostOutstanding
      ? " " + outstandingCount + " bildirim alıcı eşleştirmesi veya gönderim düzeltmesi bekliyor; iş kaydı korunuyor."
      : simulated ? " Bildirim test adapter’ında işlendi; gerçek e-posta gönderilmedi."
        : ""),
  };
}
